export enum NotificationActions {
  reload = 'reload',
  visitPage = 'visitPage',
  visitGuide = 'visitGuide',
}
